import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ClosedButtonSettings from 'Pods/ThreeDStudio/Shared/ClosedButtonSettings/ClosedButtonSettings'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { POLYGON_TYPE } from 'Pods/ThreeDStudio/Store/constants'

const labelKeys = {
  [POLYGON_TYPE.QUADRILATERAL]: 'leftSide.polygonType.quad',
  [POLYGON_TYPE.TRIANGLE]: 'leftSide.polygonType.triangular',
}

function CollapsedPolygonTypeRow() {
  const t = useTranslation()
  const polygonType = useThreeDStudioStore(state => state.modelSettings.polygonType)
  const labelKey = labelKeys[polygonType]
  const buttonLabel = labelKey ? t(labelKey) : ''
  const isActive = Boolean(buttonLabel)
  const isHidden = useThreeDStudioStore(
    state => state.schema?.generationModelSchema?.ui_schema?.polygon_type?.['ui:options']?.hidden,
  )

  if (isHidden) {
    return null
  }

  return (
    <ClosedButtonSettings
      label={t('leftSide.polygonType.label')}
      isActive={isActive}
      buttonLabel={buttonLabel}
    />
  )
}

export default memo(CollapsedPolygonTypeRow)
